import { render } from "./BootstrapDataTable.vue?vue&type=template&id=6477f29c&scoped=true&ts=true"
import script from "./BootstrapDataTable.vue?vue&type=script&lang=ts"
export * from "./BootstrapDataTable.vue?vue&type=script&lang=ts"

import "./BootstrapDataTable.vue?vue&type=style&index=0&id=6477f29c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6477f29c"]])

export default __exports__